/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {  Observable } from 'rxjs';
import { UserService } from '../../../controllers/User';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGGetFormService } from '../../yasag-get.service';


@Injectable()
export class UserCurrentFormService extends YASAGGetFormService<__model.User> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    ordering: new FormControl({value: undefined, disabled: false}, []),
    search: new FormControl({value: undefined, disabled: false}, []),
    last_login: new FormControl({value: undefined, disabled: false}, []),
    last_login__isnull: new FormControl({value: undefined, disabled: false}, []),
    limit: new FormControl({value: undefined, disabled: false}, []),
    offset: new FormControl({value: undefined, disabled: false}, []),
    fields: new FormControl({value: undefined, disabled: false}, []),
    expand: new FormControl({value: undefined, disabled: false}, []),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: UserService,
  ) {
    super('UserCurrent', apiConfigService, ngZone);
    this.init();
  }

  submit(value: typeof this.form.value | false = false, cache = true, only_cache = false): Observable<__model.User> {
    const result = val => this.service.current(val);
    return this._submit('__model.User', result, value, cache, only_cache );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<__model.User> {
    if (submit) {
      this.submit(value);
    }
    return this._listen('__model.User', value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    super.reset(value, false); 
  }
  patch(value: typeof this.form.value): void {
    this.form.patchValue(value);
  }
}
